import FeaturedProductBlock from './FeaturedProductBlock'

export default FeaturedProductBlock
